import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import CommonAutocomplete from "../../components/CommonAutocomplete";
import {
  getClosingDateGroup,
  getReceiptDivision,
} from "../../http/api/MasterAPI";

const FIELD_INDEX = {
  buyerNo: 1,
  buyerName: 2,
  buyerNameFurigana: 3,
  receiptDivisionCd: 4,
  closingDateGroupCd: 5,
  postCode: 6,
  address: 7,
  tel: 8,
  fax: 9,
  email: 10,
  businessRegistrationNo: 11,
  billingCd: 12,
  statisticsCd: 13,
};
const INDEX_FIELD = {};

for (const [key, value] of Object.entries(FIELD_INDEX)) {
  INDEX_FIELD[value] = key;
}

function handlePressKey(event) {
  if (event.key === "Enter") {
    if (event.location === 3) {
      event.preventDefault();
      focusNavigation(event.target, event.shiftKey);
    }
  }
}

function focusNavigation(currentElement, isPrevious = false) {
  const focusing = currentElement.id;
  const focusingFieldName = focusing.split("-")[2]; //example : buyer-field-buyerNo
  const nextStep = isPrevious ? -1 : 1;
  const nextIndex = FIELD_INDEX[focusingFieldName] + nextStep;

  const nextFieldName = INDEX_FIELD[nextIndex];
  setTimeout(() => {
    let nextElement = document.getElementById(`buyer-field-${nextFieldName}`);
    if (nextElement) {
      nextElement.focus();
    } else {
      console.log("next element not exist");
    }
  }, 0);
}

function handleKeyDown(event) {
  //Arrow Handle
  const keyCode = event.keyCode;
  //Arrow Key

  // Handle left arrow key press
  if (keyCode === 37) {
    event.preventDefault();
    focusNavigation(event.target, true);
  }
  // Handle right arrow key press
  else if (keyCode === 39) {
    event.preventDefault();
    focusNavigation(event.target, false);
  }
  // //Handle Key Up
  // else if (keyCode === 38) {
  //   const ariaExpanded =
  //     event.target.getAttribute("aria-expanded") === "true" ? true : false;
  //   if (!ariaExpanded) {
  //     event.preventDefault();
  //     focusNavigation(event.target, true);
  //   }
  // }
  // //Handle Key Down
  // else if (keyCode === 40) {
  //   const ariaExpanded =
  //     event.target.getAttribute("aria-expanded") === "true" ? true : false;
  //   if (!ariaExpanded) {
  //     event.preventDefault();
  //     focusNavigation(event.target, false);
  //   }
  // }

  if (event.key === "Insert" && event.location === 0) {
    event.preventDefault();
    document.getElementById("buyer-form-submit-button").focus();
    document.getElementById("buyer-form-submit-button").click();
  }
}

async function handleFocus(e) {
  // e.target.select();
}

const infoTableRowSx = {
  borderBottom: "1px solid #d3d3d3",
  textAlign: "center",
};

const infoTableCellSx = {
  fontSize: 18,
  border: "none",
};

// 新規商品登録ページ
export default function BuyerInfo(props) {
  const { buyerInfo, isUpdateMode = false } = props;
  const [receiptDivisions, setReceiptDivisions] = useState([]);
  const [closingDateGroups, setClosingDateGroups] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedClosingDateGroup, setSelectedClosingDateGroup] =
    useState(null);

  useEffect(() => {
    getReceiptDivisions();
    getClosingDateGroups();
    focusToFirstField();
  }, []);

  useEffect(() => {
    if (!receiptDivisions || !buyerInfo.Value?.receiptDivisionCd) return;
    const receiptDivision = receiptDivisions.find(
      (x) => x.receiptDivisionCd === buyerInfo.Value?.receiptDivisionCd
    );
    setSelectedDivision(receiptDivision);
  }, [buyerInfo.Value.receiptDivisionCd, receiptDivisions]);

  useEffect(() => {
    if (!closingDateGroups) return;
    const closingDateGroup = closingDateGroups.find(
      (x) => x.closingDateGroupCd === buyerInfo.Value?.closingDateGroupCd
    );
    setSelectedClosingDateGroup(closingDateGroup);
  }, [buyerInfo.Value.closingDateGroupCd, closingDateGroups]);

  async function getReceiptDivisions() {
    const response = await getReceiptDivision();
    const listReceiptDivision = response.masterVarInfo.map(
      ({ varCd, varValue1 }) => ({
        receiptDivisionCd: varCd,
        receiptDivisionName: varValue1,
      })
    );
    setReceiptDivisions(listReceiptDivision);
  }

  async function getClosingDateGroups() {
    const response = await getClosingDateGroup();
    const listClosingDateGroup = response.masterVarInfo.map(
      ({ varCd, varValue1 }) => ({
        closingDateGroupCd: varCd,
        closingDateGroupContent: varValue1,
      })
    );
    const nonSelect = {
      closingDateGroupCd: null,
      closingDateGroupContent: "未選択",
    };
    setClosingDateGroups([nonSelect,...listClosingDateGroup]);
  }

  function focusToFirstField() {
    const focusId = isUpdateMode
      ? "buyer-field-buyerName"
      : "buyer-field-buyerNo";
    document.getElementById(focusId).focus();
  }
  return (
    <TableContainer
      component={Box}
      onKeyPress={handlePressKey}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
    >
      <Table>
        <TableBody>
          <TableRow sx={infoTableRowSx}>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  買人No&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container alignItems="center">
                <OutlinedInput
                  onChange={(e) => buyerInfo.update("buyerNo", e.target.value)}
                  value={buyerInfo.Value.buyerNo}
                  sx={{ width: 100 }}
                  disabled={isUpdateMode}
                  id={`buyer-field-buyerNo`}
                />
                <Grid item xs></Grid>
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow sx={infoTableRowSx}>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  買人名&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container alignItems="center">
                <OutlinedInput
                  onChange={(e) =>
                    buyerInfo.update("buyerName", e.target.value)
                  }
                  value={buyerInfo.Value.buyerName}
                  sx={{ width: 400 }}
                  id={`buyer-field-buyerName`}
                />
                {/* <Grid item xs>
                  <span style={{fontSize:14}}={14}>半角数字のみ</Typography>
                </Grid> */}

                <Grid item xs="auto" ml={5}>
                  フリガナ&nbsp;
                </Grid>
                <OutlinedInput
                  onChange={(e) =>
                    buyerInfo.update("buyerNameFurigana", e.target.value)
                  }
                  value={buyerInfo.Value.buyerNameFurigana}
                  sx={{ width: 400 }}
                  id={`buyer-field-buyerNameFurigana`}
                />
                {/* <Grid item xs>
                  <span style={{fontSize:14}}={14}>半角数字のみ</Typography>
                </Grid> */}
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow sx={infoTableRowSx}>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  入金区分&nbsp;
                </Grid>
                <Grid item xs="auto">
                  <Typography color="error">(必須)</Typography>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <CommonAutocomplete
                value={selectedDivision || null}
                onSelect={(e, newValue) => {
                  buyerInfo.update(
                    "receiptDivisionCd",
                    newValue.receiptDivisionCd
                  );
                  focusNavigation(document.activeElement, false);
                }}
                id={`buyer-field-receiptDivisionCd`}
                data={receiptDivisions}
                filterOptions={(options, { inputValue }) => {
                  inputValue = inputValue.trim();
                  return options.filter((x) => {
                    return x.receiptDivisionName.includes(inputValue);
                  });
                }}
                optionLabel={(option) =>
                  option ? option.receiptDivisionName : ""
                }
                width={120}
              />
            </TableCell>
          </TableRow>

          <TableRow sx={infoTableRowSx}>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  締日グループ&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <CommonAutocomplete
                value={selectedClosingDateGroup || null}
                onSelect={(e, newValue) => {
                  buyerInfo.update(
                    "closingDateGroupCd",
                    newValue.closingDateGroupCd
                  );
                  focusNavigation(document.activeElement, false);
                }}
                id={`buyer-field-closingDateGroupCd`}
                data={closingDateGroups}
                filterOptions={(options, { inputValue }) => {
                  inputValue = inputValue.trim();
                  return options.filter((x) => {
                    return x.closingDateGroupContent.includes(inputValue);
                  });
                }}
                optionLabel={(option) =>
                  option
                    ? option.closingDateGroupContent?.replace("99", "月末")
                    : ""
                }
                width={120}
                defaultValue={{
                  closingDateGroupCd: null,
                  closingDateGroupContent: "未選択",
                }}
              />
            </TableCell>
          </TableRow>

          <TableRow sx={infoTableRowSx}>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  住所&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={2}>
                <Grid item xs="auto">
                  〒&nbsp;
                  <OutlinedInput
                    onChange={(e) =>
                      buyerInfo.update("postCode", e.target.value)
                    }
                    value={buyerInfo.Value.postCode}
                    sx={{ width: 100 }}
                    id={`buyer-field-postCode`}
                  />
                </Grid>
                <Grid item xs="auto">
                  <OutlinedInput
                    onChange={(e) =>
                      buyerInfo.update("address", e.target.value)
                    }
                    value={buyerInfo.Value.address}
                    sx={{ width: 400 }}
                    id={`buyer-field-address`}
                  />
                  <span style={{ fontSize: 14, marginLeft: 5 }}>
                    郵便番号は半角数字のみ
                  </span>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow sx={infoTableRowSx}>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  連絡先&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid container spacing={5}>
                <Grid item xs="auto">
                  TEL&nbsp;
                  <OutlinedInput
                    onChange={(e) => buyerInfo.update("tel", e.target.value)}
                    value={buyerInfo.Value.tel}
                    sx={{ width: 150 }}
                    id={`buyer-field-tel`}
                  />
                  <span style={{ fontSize: 14, marginLeft: 5 }}>
                    半角数字, ハイフン(-)のみ
                  </span>
                </Grid>
                <Grid item xs="auto">
                  FAX&nbsp;
                  <OutlinedInput
                    onChange={(e) => buyerInfo.update("fax", e.target.value)}
                    value={buyerInfo.Value.fax}
                    sx={{ width: 150 }}
                    id={`buyer-field-fax`}
                  />
                  <span style={{ fontSize: 14, marginLeft: 5 }}>
                    半角数字, ハイフン(-)のみ
                  </span>
                </Grid>
                <Grid item xs="auto">
                  メール&nbsp;
                  <OutlinedInput
                    onChange={(e) => buyerInfo.update("email", e.target.value)}
                    value={buyerInfo.Value.email}
                    sx={{ width: 350 }}
                    id={`buyer-field-email`}
                  />
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow sx={infoTableRowSx}>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  事業者登録番号&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid>
                <OutlinedInput
                  onChange={(e) =>
                    buyerInfo.update("businessRegistrationNo", e.target.value)
                  }
                  value={buyerInfo.Value.businessRegistrationNo}
                  sx={{ width: 200 }}
                  id={`buyer-field-businessRegistrationNo`}
                />
                <span style={{ fontSize: 14, marginLeft: 5 }}>
                  ハイフンは含まない
                </span>
              </Grid>
            </TableCell>
          </TableRow>

          <TableRow sx={infoTableRowSx}>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  請求先コード&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid>
                <OutlinedInput
                  onChange={(e) =>
                    buyerInfo.update("billingCd", e.target.value)
                  }
                  value={buyerInfo.Value.billingCd}
                  sx={{ width: 200 }}
                  id={`buyer-field-billingCd`}
                />
                <span style={{ fontSize: 14, marginLeft: 5 }}>
                  半角数字のみ
                </span>
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell width={210} sx={infoTableCellSx}>
              <Grid container>
                <Grid item xs="auto">
                  統計先コード&nbsp;
                </Grid>
              </Grid>
            </TableCell>
            <TableCell sx={infoTableCellSx}>
              <Grid>
                <OutlinedInput
                  onChange={(e) =>
                    buyerInfo.update("statisticsCd", e.target.value)
                  }
                  value={buyerInfo.Value.statisticsCd}
                  sx={{ width: 200 }}
                  id={`buyer-field-statisticsCd`}
                />
                <span style={{ fontSize: 14, marginLeft: 5 }}>
                  半角数字のみ
                </span>
              </Grid>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
